/**
 * Minimum chart grid height (in px) required to display annotations.
 * Below this threshold, annotations are hidden to prevent visual clipping.
 * @internal
 */
export const MIN_HEIGHT_FOR_ANNOTATIONS = 160;

/**
 * Minimum chart grid height (in px) required to display top/bottom axes.
 * Below this threshold, axes are hidden to maximize the plot area.
 * @internal
 */
export const MIN_HEIGHT_FOR_AXES = 50;

/**
 * Determines whether annotations should be visible based on chart height
 * and whether annotation tracks exist.
 * @internal
 */
export function shouldShowAnnotations(
  chartGridHeight: number,
  tracksQuantity: number,
): boolean {
  return tracksQuantity > 0 && chartGridHeight >= MIN_HEIGHT_FOR_ANNOTATIONS;
}

/**
 * Determines whether top/bottom axes should be visible based on chart height.
 * @internal
 */
export function shouldShowAxes(chartGridHeight: number): boolean {
  return chartGridHeight >= MIN_HEIGHT_FOR_AXES;
}
